export const useDefaultData = () => {

    const defaultDataModal = {
        open: false,
        titleModal: '',
        componentModal: '',
        dataRequest: {},
    }

    const defaultFormScreen = {
        idbank: '',
        name: '',
        currency_type: 'QUETZAL',
        state: 1
    }

    return Object.freeze({
        defaultDataModal,
        defaultFormScreen
    })
}